<template>
  <div class="StartButton">
    <div class="button">
      <my_button value="获取题目" @click.native="showModal" :disable="!!rank.submitted"></my_button>
    </div>
    <modal name="confirm-modal"
           :width="800"
           :height="800"
           :adaptive="true">
      <confirm-start></confirm-start>
    </modal>
    <modal name="no-access"
           :width="800"
           :height="600"
    >
      <no_access></no_access>
    </modal>
    <modal name="not-paid"
           :width="800"
           :height="600"
    >
      <not_paid></not_paid>
    </modal>
  </div>
</template>

<script>
import MyButton from '@/components/Button.vue';
import ConfirmStart from '@/components/contest/ConfirmStart.vue'
import NoAccess from '@/components/contest/NoAccess.vue'
import NotPaid from '@/components/contest/NotPaid.vue'
import moment from 'moment'

export default {
  name: 'StartButton',
  components: {
    my_button: MyButton,
    'confirm-start': ConfirmStart,
    no_access: NoAccess,
    not_paid: NotPaid
  },
  data () {
    return {
      rank: {}
    }
  },
  mounted () {
    this.$http.get('/api/rank/me').then(res => {
      this.rank = res.data
    })
  },
  computed: {
     user() {
       return this.$store.state.auth.user
     },
    correctTime() {
      return moment(+new Date() + this.$store.state.timeDelay)
    },
    timeSets () {
      return this.$store.state.enroll.timeSets
    },
    inTime () {
      let inTime = false
      this.timeSets.forEach((timeSet) => {
        if (this.correctTime.isBetween(timeSet.start, timeSet.end)) {
          inTime = true
        }
      })
      return inTime
    }

  },
  methods: {
    showModal() {
      if(this.user) {
        if (!this.user.enrolled) {
          this.$router.push({name: 'enroll'})
          return
        }
        if (this.rank.user_id) {
          if (this.rank.submitted) {
            return
          }
          this.$router.push({name: 'contest'})
          return
        }
        if (!this.inTime) {
          this.$modal.show('no-access')
        } else {
          if(this.user.paid) {
            this.$modal.show('confirm-modal');
          } else {
            this.$modal.show('not-paid')
          }
        }
      } else {
        this.$store.commit('SET_REDIRECT', this.$router.currentRoute.fullPath)
        this.$router.push({name:'account', params:{type:'login'}})
      }

    }
  }
}

</script>

<style scoped>
.StartButton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button {
  min-width: 150px;
  width: 200px;
}

</style>